export enum WorkflowId {
  PAYMENTS = 'payments',
  MAINTENANCE = 'maintenance',
  LEASE = 'lease',
}

export enum HighlightRole {
  ACTIONABLE = 'actionable',
  HIGHLIGHT = 'highlight',
}

export enum StepActionKind {
  NEXT = 'next',
  BACK = 'back',
  GO_TO = 'goTo',
  RESET = 'reset',
  EXIT = 'exit',
}

export enum CommonStepId {
  TOUR_COMPLETE = 'tour.complete',
}

export enum TourStepPrefix {
  MANAGER = 'mgr.',
  TENANT = 'tenant.',
}

export enum AnchorId {
  BALANCE_AMOUNT_DUE = 'balance.amountDue',
  MAINTENANCE_ASSIGN_VENDOR = 'maintenance.assignVendor',
  MAINTENANCE_OPEN_REQUEST_MODAL = 'maintenance.openRequestModal',
  MAINTENANCE_REQUEST_BODY = 'maintenance.requestBody',
  MAINTENANCE_REQUEST_LIST = 'maintenance.requestList',
  MAINTENANCE_REQUEST_ROW = 'maintenance.requestRow',
  MAINTENANCE_RETURN_TO_MANAGER = 'maintenance.returnToManager',
  MAINTENANCE_STATUS_OPTION_IN_PROGRESS = 'maintenance.statusOption.inProgress',
  MAINTENANCE_SUBMIT_REQUEST = 'maintenance.submitRequest',
  MAINTENANCE_UPDATE_STATUS = 'maintenance.updateStatus',
  MAINTENANCE_VENDOR_OPTION_FISHER = 'maintenance.vendorOption.fisher',
  MANAGER_CLEARED_PLACEHOLDER = 'managerCleared.placeholder',
  MANAGER_CLEARED_TRANSACTIONS_TAB = 'managerCleared.transactionsTab',
  MANAGER_OUTSTANDING_OUTSTANDING_INVOICE = 'managerOutstanding.outstandingInvoice',
  MANAGER_TRANSACTIONS_RENT_PAYMENT = 'managerTransactions.rentPayment',
  OPEN_TENANT_VIEW_BUTTON = 'open-tenant-view-button',
  TENANT_PAYMENTS_INVOICE_ACCORDION = 'tenantPayments.invoiceAccordion',
  TENANT_PAYMENTS_MAKE_PAYMENT = 'tenantPayments.makePayment',
  TENANT_REVIEW_ACCORDION_LIST = 'tenantReview.accordionList',
  TENANT_REVIEW_INVOICE_ACCORDION = 'tenantReview.invoiceAccordion',
  TENANT_REVIEW_PAY_NOW = 'tenantReview.payNow',
  TENANT_REVIEW_PROCESSING = 'tenantReview.processing',
  TENANT_REVIEW_SUCCESS_CONTINUE = 'tenantReview.successContinue',
  TENANT_REVIEW_TOTAL_ACCORDION = 'tenantReview.totalAccordion',
  TOUR_CHECKLIST_PANEL = 'tourChecklist.panel',
}
